'use client';

import H2 from '@/components/typography/h2';
import Copiable from '@/components/ui/copiable';
import { useTranslation } from 'react-i18next';

export default function Contact() {
    const { t } = useTranslation();
    return (
        <div className="border-primary border-b px-6 pt-[60px] pb-25 xl:py-40">
            <div className="flex justify-center">
                <H2 className="max-w-[78.1875rem] text-center">
                    {t('contact.title')}
                    <Copiable label="Email Laura" value={t('contact.email')}>
                        <span className="underline decoration-2 underline-offset-4 hover:no-underline">
                            {t('contact.email')}
                        </span>
                    </Copiable>
                </H2>
            </div>
        </div>
    );
}
